export enum workerTypeEnum {
  pharmacist = "pharmacist",
  technician = "technician",
  assistant = "assistant",
  pharmacistStudent = "pharmacist_student",
  technicianStudent = "technician_student",

  dentist = 'dentist_dentist',
  denturist = 'dentist_denturist',
  dentistRDH = 'dentist_rdh',
  dentistLDH = 'dentist_ldh',
  dentistRDA = 'dentist_rda',
  dentistAdministrator = 'dentist_administrator',
  dentistSterilizationAssistant = 'dentist_sterilizationAssistant',
  dentistCDA = 'dentist_cda', 
  dentistLDA = 'dentist_lda',
  dentistCDA2 = 'dentist_cda_2',
  dentistRDT = 'dentist_rdt',
  dentistDT = 'dentist_technician',
  dentistChairSideAssistant = 'dentist_chairSideAssistant',
  dentistDA1 = 'dentist_da1',
  dentistDA2 = 'dentist_da2',
  dentistDA12 = 'dentist_da1_2',

  LabourMechanical = 'labour_mechanical',
  LabourPlumber = 'labour_plumber',
  LabourElectrical = 'labour_electrical'
}

export enum paymentTypeEnum {
  creditCard = 'credit_card',
  pad = 'pad',
  invoice= 'invoice',
  // Canonical RB Pay value (matches RB_PAY_PAYMENT_METHOD / BE PaymentTypeEnum.RbPay)
  rbPay = 'rb_pay'
}

export enum FormattedWorkerTypeEnum {
  pharmacist = 'Pharmacist',
  technician = 'Technician',
  assistant = 'Assistant',
  pharmacistStudent = 'Pharmacy Student',
  technicianStudent = 'Technician Student',
  pharmacistConditionalLicense = 'Pharmacist - Conditional License',
  pharmacistIntern2020Grad = 'Intern - 2020 Grad',

  dentist = 'Dentist',
  denturist = 'Denturist',
  dentistRDH = 'RDH: Reg. Dental Hygienist',
  dentistLDH = 'LDH: Lic. Dental Hygienist (BC)',
  dentistRDA = 'RDA: Reg. Dental Assistant',
  dentistAdministrator = 'Dental Administrator',
  dentistSterilizationAssistant = 'Sterilization/Floater',
  dentistLDA = 'LDA: Lic. Dental Assistant (BC)',
  dentistCDA2 = 'CDA II: Cert. Dental Asst. LII',
  dentistRDT = 'RDT: Reg. Dental Tech.',
  dentistDT = 'Dental Technician',
  dentistCDA = 'CDA: Cert. Dental Assistant', 
  dentistChairSideAssistant = 'Chairside Assistant',
  dentistDA1 = 'Dental Assistant I (Ontario)',
  dentistDA2 = 'Dental Assistant II (Ontario)',
  dentistDA12 = 'Dental Assistant I or II (Ontario)',

  labourMechanical = 'Mechanical',
  labourPlumber = 'Plumbing',
  labourElectrical = 'Electrical'
}

export enum locationTypeEnum {
  pharmacy = '',
  dentalPratcice = 'dental_practice', 
  dentalProvider = 'dental_provider'
}

export enum formattedLocationTypeEnum {
  pharmacy = 'Pharmacy',
  dentalPratcice = 'Dental Practice', 
  dentalProvider = 'Dental Provider'
} 

export enum SkillType {
  software = "software",
  language = "language",
  specialization = "specialization",
  dentalSoftware = "dentalSoftware"
}

export enum HelperPageTitleEnum {
  termOfService = "Terms of Service",
  faq = "FAQ",
  privacyPolicy = "Privacy Policy",
  aboutReliefBuddy = "About",
}
